import React, { useState } from "react";
import { Box, Typography, IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { styled } from "@mui/system";

// Styled Component for Title Bar
const TitleBar = styled(Box)(({ theme }) => ({
  background: theme.palette.background.paper,
  padding: "16px 24px",
  borderRadius: "16px",
  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
  maxWidth: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: "20px",
  border: `2px solid ${
    theme.palette.mode === "dark"
      ? theme.palette.primary.dark
      : theme.palette.primary.main
  }`,
}));

const Title = ({ text, icon, showActions = false, actions = [] }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <TitleBar>
      {/* Left Side */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        {icon && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              color: "primary.main",
            }}
          >
            {icon}
          </Box>
        )}

        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{
            lineHeight: 1,
            margin: 0,
            color: (theme) =>
              theme.palette.mode === "dark"
                ? theme.palette.primary.dark
                : theme.palette.primary.main,
          }}
        >
          {text}
        </Typography>
      </Box>

      {/* Right Side Actions */}
      {showActions && (
        <>
          <IconButton onClick={handleMenuOpen}>
            <MoreVertIcon
              sx={{
                color: (theme) =>
                  theme.palette.mode === "dark"
                    ? theme.palette.primary.dark
                    : theme.palette.primary.main,
              }}
            />
          </IconButton>

          <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
            {actions.map((action, index) => (
              <MenuItem
                key={index}
                onClick={() => {
                  handleMenuClose();
                  action.onClick();
                }}
              >
                {action.label}
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
    </TitleBar>
  );
};

export default Title;
